export default function deleteEntrySuccess(state, payload) {
  const { toDelete } = payload;

  return {
    ...state,
    isFetching: false,
    sharedContent: state.sharedContent.filter(({ id }) => id !== toDelete),
  };
}